import { useContext } from "react";
import style from "./style.less";
import HomeHeaderOther from "@/components/HomeHeader/indexOther";
import MyNavLink from "@/components/MyNavLink";
import { LanguageContext } from "@/data/LanguageProvider";
import { LocalConfig } from "@/config";
import { useLocation } from "react-router-dom";

const WithdrawControl = () => {
  const { langText } = useContext(LanguageContext);
  const fromBank = new URLSearchParams(useLocation().search).get("from") === "bank";
  return (
    <div class={style.withdraw_control_container}>
      <HomeHeaderOther title={fromBank ? langText("bank_status_review") : "Risk control tips"} backToUrl={fromBank ? "/bank" : undefined} />
      <div class={style.withdraw_control_top}>
        <p>Your withdrawal request has been submitted. </p>
        <p>{fromBank ? langText("bank_withdraw_review") : "Our staff is currently processing it, and it is expected to be completed within 15 minutes to 24 hours."}</p>
        <p>We appreciate your patience and understanding during this time.</p>
      </div>
      <div class={style.withdraw_control_intro}>
        <MyNavLink to="/contact" style={{ textDecoration: "underline" }}>
          Contact Us
        </MyNavLink>
      </div>
      <div class={style.withdraw_control_footer}>
        <img src={require("@/assets/images/home/18_plus.png").default} />
        <span>© {LocalConfig.gameName} {langText("common_tips_1")}</span>
      </div>
    </div>
  );
};

export default WithdrawControl;
